import API from "@/utils/Api";
import { get } from "@/context/context";
import { AxiosResponse } from "axios";
import { RequestConfig } from "@/models/RequestConfig";
import AuthRepository from "@/repositories/AuthRepository";
import { UserLoginRequest } from "@/models/User/UserLoginRequest";
import { UserResponse } from "@/models/User/UserResponse";
import { UserRegisterResponse } from "@/models/User/UserRegisterResponse";
import { UserRegisterRequest } from "@/models/User/UserRegisterRequest";
import { UserResetPasswordRequest } from "@/models/User/UserResetPasswordRequest";
import { UserSaveResetPasswordRequest } from "@/models/User/UserSaveResetPasswordRequest";

export class AuthApi implements AuthRepository {

    private api: API = get('api');

    public async login(payload: UserLoginRequest, config?: RequestConfig): Promise<UserResponse> {
        const response: AxiosResponse<UserResponse> =
            await this.api.post('/uploader/wix/sign-in', payload, config);
        const { data } = response;
        return data;
    }

    public async getByEmail(email: string, config?: RequestConfig): Promise<UserResponse> {
        const response: AxiosResponse<UserResponse> =
            await this.api.get('/uploader/wix/user-id?email='+email);
        const { data } = response;
        return data;
    }

    public async register(payload: UserRegisterRequest, config?: RequestConfig): Promise<UserRegisterResponse> {
        const response: AxiosResponse<UserRegisterResponse> =
            await this.api.post('/uploader/wix/sign-up', payload, config);
        const { data } = response;
        return data;
    }

    public async resetPassword(payload: UserResetPasswordRequest, config?: RequestConfig): Promise<void> {
        const email = encodeURIComponent(payload.email).toLowerCase();
        await this.api.get(`/restore-password?email=${email}`, config);
    }

    public async resetPasswordSave(payload: UserSaveResetPasswordRequest, config?: RequestConfig): Promise<void> {
        await this.api.put('/restore-password', payload, config);
    }

}
